import React from 'react';
import {
  Modal,
  Input,
  Button,
  Select,
  Icon,
  Col,
  Row,
  Upload,
  Tooltip,
  Spin
} from 'antd';
import anger from '../../../images/emoticons/anger.png';
import boredom from '../../../images/emoticons/boredom.png';
import excitement from '../../../images/emoticons/excitement.png';
import fascination from '../../../images/emoticons/fascination.png';
import joy from '../../../images/emoticons/joy.png';
import love from '../../../images/emoticons/love.png';
import sad from '../../../images/emoticons/sad.png';
import worry from '../../../images/emoticons/worry.png';
import MultipleSelect from './multipleSelect.js';
import ReviewPopup from './reviewPopup.js';
import DisabledPopup from './disabledPopup.js';
import moment from 'moment';
import { pathOr } from 'ramda';
const { TextArea } = Input;
const Option = Select.Option;

class Reflection extends React.Component {
  state = {
    learnerProfile: [],
    serviceLearning: [],
    editingSelection: false,
    type: [],
    categories: [],
    impact: '',
    notes: '',
    reflection: '',
    reviewPopup: false,
    disabledPopup: false,
    confirmPopup: false,
    feeling: null,
    why_emoticon: '',
    uploading: false
  };

  componentWillUnmount = () => {
    this.saveData();
  };

  componentDidMount = () => {
    const { data, disabled, show_popup, feeling } = this.props;
    if (data) {
      this.setState({
        notes: data.notes,
        serviceLearning: data.learningOutcomes || [],
        learnerProfile: data.learnerProfileAttribute || [],
        impact: data.actualImpact,
        categories: data.ATLCategories || [],
        reflection: data.writeReflection,
        feeling,
        why_emoticon: data.why_emoticon
      });
    }
    if (!disabled && show_popup) {
      this.setState({ reviewPopup: true });
    }
  };

  confirmMultiple = selection => {
    const editing = this.state.editingSelection;
    this.setState({ [editing]: selection, editingSelection: false }, () =>
      this.saveData()
    );
  };

  cancelField = (field, category) => {
    let fields = this.state[category];
    fields = fields.filter(item => item !== field);
    this.setState({ [category]: fields }, () => this.saveData());
  };

  saveData = toNextPhase => {
    const data = {
      Reflection: {
        is_complete: true,
        actualImpact: this.state.impact,
        learnerProfileAttribute: this.state.learnerProfile,
        learningOutcomes: this.state.serviceLearning,
        notes: this.state.notes,
        ATLCategories: this.state.categories,
        writeReflection: this.state.reflection,
        uploadEvidence: this.props.data.uploadEvidence,
        why_emoticon: this.state.why_emoticon
      },
      feeling: this.state.feeling
    };
    if (toNextPhase) {
      data.current_phase = 'Demonstration';
      this.props.saveData(data);
    } else {
      this.props.saveData(data);
    }
  };

  isDisabled = () => {
    const {
      learnerProfile,
      serviceLearning,
      categories,
      impact,
      reflection,
      feeling,
      why_emoticon
    } = this.state;
    const uploads = pathOr([], ['data', 'uploadEvidence'], this.props);
    if (
      reflection === '' ||
      learnerProfile.length == 0 ||
      serviceLearning.length == 0 ||
      categories.length == 0 ||
      impact === '' ||
      feeling === null ||
      uploads.length == 0 ||
      why_emoticon == ''
    ) {
      return true;
    } else {
      return false;
    }
  };

  uploadFile = file => {
    this.setState({ uploading: true });
    const { firebase, uid, editingId } = this.props;
    let documents = (this.props.data && this.props.data.uploadEvidence) || [];
    firebase
      .uploadFile(`/projects/${uid}/${editingId}/Reflection`, file.file)
      .then(snapshot => {
        documents.push({
          url: snapshot.uploadTaskSnaphot.metadata.downloadURLs[0],
          name: file.file.name
        });
        firebase
          .database()
          .ref(`/projects/${uid}/${editingId}/Reflection/uploadEvidence/`)
          .set(documents);
        this.setState({ uploading: false });
      });
  };

  deleteFile = url => {
    const { firebase, uid, editingId } = this.props;
    const path = firebase.storage().refFromURL(url).location.path;
    firebase.deleteFile(path);
    let documents = this.props.data && this.props.data.uploadEvidence;
    documents = documents && documents.filter(item => item.url !== url);
    firebase
      .database()
      .ref(`/projects/${uid}/${editingId}/Reflection/uploadEvidence`)
      .set(documents);
  };

  dontShowPopup = () => {
    const { firebase, uid, editingId } = this.props;
    this.setState({ reviewPopup: false });
    firebase
      .database()
      .ref(`/projects/${uid}/${editingId}`)
      .update({
        show_popup: false
      });
  };

  getEmoticonStyle = emoticon => {
    const { feeling } = this.state;
    const { disabled } = this.props;
    return {
      width: 'max-content',
      opacity: disabled || feeling === emoticon ? 1 : 0.3,
      cursor: 'pointer'
    };
  };

  toggleEmoticon = emoticon => {
    // let { feeling } = this.state
    // if (feeling.includes(emoticon)) {
    //   feeling = feeling.filter( item => item !== emoticon)
    // } else if (feeling.length <= 2) {
    //   feeling.push(emoticon)
    // }
    this.setState({ feeling: emoticon });
  };

  render() {
    const { color, t, disabled, projectCompleted } = this.props;
    const { uploading } = this.state;
    const loadingIcon = (
      <Icon
        type="loading"
        style={{ fontSize: 24, marginLeft: 10, color }}
        spin
      />
    );

    const styles = {
      titleDiv: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: 20
      },
      title: {
        marginBottom: 0,
        fontSize: 16,
        fontFamily: 'Arial Rounded MT Bold',
        color: color,
        alignSelf: 'left'
      },
      addMultiple: {
        backgroundColor: disabled ? '#d0d0d0' : 'white',
        borderRadius: 20,
        height: 45,
        marginTop: 10,
        position: 'relative',
        border: `1px solid ${color}`,
        cursor: 'pointer'
      },
      nextBtn: {
        fontSize: 16,
        backgroundColor: this.props.color,
        width: '100%',
        position: 'fixed',
        bottom: 0,
        textAlign: 'center',
        color: 'white',
        padding: 10,
        cursor: 'pointer'
      },
      disabledNextBtn: {
        fontSize: 16,
        backgroundColor: '#d0d0d0',
        width: '100%',
        position: 'fixed',
        bottom: 0,
        textAlign: 'center',
        color: 'white',
        padding: 10,
        cursor: 'not-allowed'
      },
      uploadBtn: {
        fontSize: 20,
        fontFamily: 'Times new roman',
        color: 'white',
        backgroundColor: color,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 30,
        width: 30,
        borderRadius: '50%',
        cursor: 'pointer',
        boxShadow: '0 2px 3px 0 rgba(0,0,0,0.5)'
      },
      emotionImg: {
        width: 35,
        display: 'block',
        margin: '0 auto'
      },
      emotionTxt: {
        fontSize: 10,
        fontFamily: 'Arial Rounded MT Bold',
        textAlign: 'center'
      }
    };
    let documents = [];
    documents = this.props.data && this.props.data.uploadEvidence;
    return (
      <div style={{ position: 'absolute', width: '100%', top: 260 }}>
        <div style={{ maxWidth: 650, margin: '0 auto', paddingBottom: 70 }}>
          <div style={styles.titleDiv}>
            <h3 style={styles.title}>{t('Learner profile attributes')}</h3>
            <Tooltip title="Which Learner profile attributes did you develop while working on this project? These may be different to the attributes you selected at the start of the project.">
              <img style={{ height: 16, width: 16 }} src={this.props.icon} />
            </Tooltip>
          </div>
          <div
            onClick={() =>
              disabled || projectCompleted
                ? this.setState({ disabledPopup: true })
                : this.setState({
                    editingSelection: 'learnerProfile',
                    mode: 'multiple'
                  })
            }
            style={
              projectCompleted
                ? Object.assign(styles.addMultiple, {
                    backgroundColor: '#d0d0d0'
                  })
                : styles.addMultiple
            }>
            <Icon
              style={{
                color: color,
                position: 'absolute',
                right: 15,
                top: 10,
                fontSize: 21
              }}
              type="plus"
            />
          </div>
          <Row style={{ marginLeft: -10, marginRight: -10 }}>
            {this.state.learnerProfile &&
              this.state.learnerProfile.map(item => (
                <Col xs={8} style={{ padding: 10 }}>
                  <div
                    style={{
                      borderRadius: 10,
                      backgroundColor: color,
                      fontSize: 14,
                      color: 'white',
                      padding: 10,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between'
                    }}>
                    <span>{t(item)}</span>
                    {!projectCompleted && (
                      <span
                        onClick={() => this.cancelField(item, 'learnerProfile')}
                        style={{
                          float: 'right',
                          width: 20,
                          textAlign: 'right',
                          cursor: 'pointer'
                        }}>
                        X
                      </span>
                    )}
                  </div>
                </Col>
              ))}
          </Row>
          <div style={styles.titleDiv}>
            <h3 style={styles.title}>
              {t('Relevant Service Learning Outcomes')}
            </h3>
            <Tooltip title="What service learning outcomes did you feel you achieved as a result of this project? These may be different to the ones you selected at the start of the project.">
              <img style={{ height: 16, width: 16 }} src={this.props.icon} />
            </Tooltip>
          </div>
          <div
            onClick={() =>
              disabled || projectCompleted
                ? this.setState({ disabledPopup: true })
                : this.setState({
                    editingSelection: 'serviceLearning',
                    mode: 'multiple'
                  })
            }
            style={
              projectCompleted
                ? Object.assign(styles.addMultiple, {
                    backgroundColor: '#d0d0d0'
                  })
                : styles.addMultiple
            }>
            <Icon
              style={{
                color: color,
                position: 'absolute',
                right: 15,
                top: 10,
                fontSize: 21
              }}
              type="plus"
            />
          </div>
          <Row style={{ marginLeft: -10, marginRight: -10 }}>
            {this.state.serviceLearning &&
              this.state.serviceLearning.map(item => (
                <Col xs={24} style={{ padding: 10 }}>
                  <div
                    style={{
                      borderRadius: 10,
                      backgroundColor: color,
                      fontSize: 14,
                      color: 'white',
                      padding: 10,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between'
                    }}>
                    <span>{t(item)}</span>
                    {!projectCompleted && (
                      <span
                        onClick={() =>
                          this.cancelField(item, 'serviceLearning')
                        }
                        style={{
                          float: 'right',
                          width: 20,
                          textAlign: 'right',
                          cursor: 'pointer'
                        }}>
                        X
                      </span>
                    )}
                  </div>
                </Col>
              ))}
          </Row>

          <div style={styles.titleDiv}>
            <h3 style={styles.title}>{t('Skills')}</h3>
          </div>
          <div
            onClick={() =>
              disabled || projectCompleted
                ? this.setState({ disabledPopup: true })
                : this.setState({
                    editingSelection: 'categories',
                    mode: 'multiple'
                  })
            }
            style={
              projectCompleted
                ? Object.assign(styles.addMultiple, {
                    backgroundColor: '#d0d0d0'
                  })
                : styles.addMultiple
            }>
            <Icon
              style={{
                color: color,
                position: 'absolute',
                right: 15,
                top: 10,
                fontSize: 21
              }}
              type="plus"
            />
          </div>
          <Row style={{ marginLeft: -10, marginRight: -10 }}>
            {this.state.categories &&
              this.state.categories.map(item => (
                <Col xs={8} style={{ padding: 10 }}>
                  <div
                    style={{
                      borderRadius: 10,
                      backgroundColor: color,
                      fontSize: 14,
                      color: 'white',
                      padding: 10,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between'
                    }}>
                    <span>{t(item)}</span>
                    {!projectCompleted && (
                      <span
                        onClick={() => this.cancelField(item, 'categories')}
                        style={{
                          float: 'right',
                          width: 20,
                          textAlign: 'right',
                          cursor: 'pointer'
                        }}>
                        X
                      </span>
                    )}
                  </div>
                </Col>
              ))}
          </Row>

          <div style={styles.titleDiv}>
            <h3 style={styles.title}>{t('Impact')}</h3>
            <Tooltip title="Describe the impact that the project has had on other people, organizations and/or the environment.">
              <img style={{ height: 16, width: 16 }} src={this.props.icon} />
            </Tooltip>
          </div>
          <div
            onClick={() => disabled && this.setState({ disabledPopup: true })}>
            <TextArea
              onBlur={() => this.saveData()}
              rows={4}
              disabled={disabled || projectCompleted}
              onChange={e => this.setState({ impact: e.target.value })}
              style={{
                marginTop: 10,
                border: `1px solid ${color}`,
                fontSize: 16
              }}
              value={this.state.impact}
            />
          </div>

          <div style={styles.titleDiv}>
            <h3 style={styles.title}>{t('Compose your reflection')}</h3>
            <Tooltip title="Look back at your previous answers to compose your reflection. How did the project change you as a person? How has the project changed the way you think, feel and act? Would you do anything differently if you did this again? Note that reflections can be written, visual, oral or a combination of these.">
              <img style={{ height: 16, width: 16 }} src={this.props.icon} />
            </Tooltip>
          </div>
          <div
            onClick={() => disabled && this.setState({ disabledPopup: true })}>
            <TextArea
              onBlur={() => this.saveData()}
              rows={4}
              disabled={disabled || projectCompleted}
              onClick={() => disabled && this.setState({ disabledPopup: true })}
              onChange={e => this.setState({ reflection: e.target.value })}
              style={{
                marginTop: 10,
                border: `1px solid ${color}`,
                fontSize: 16
              }}
              value={this.state.reflection}
            />
          </div>

          <div style={styles.titleDiv}>
            <div>
              <div style={{ display: 'flex' }}>
                <h3 style={styles.title}>
                  {t('Upload reflection/presentation/documents')}
                  {uploading && <Spin indicator={loadingIcon} />}
                </h3>
              </div>
              <p
                style={{
                  fontFamily: 'Helvetica Neue',
                  fontSize: 12,
                  margin: 0,
                  color: color
                }}>
                {t('(Maximum 5 attachments)')}
              </p>
            </div>
            {!projectCompleted && (
              <Upload
                disabled={disabled}
                customRequest={this.uploadFile}
                showUploadList={false}>
                <div style={styles.uploadBtn}>+</div>
              </Upload>
            )}
          </div>
          <Row style={{ width: '100%' }}>
            {documents &&
              documents.length > 0 &&
              documents.map(item => (
                <Col xs={24} style={{ padding: 0, marginTop: 10 }}>
                  <div
                    style={{
                      borderRadius: 10,
                      backgroundColor: color,
                      fontSize: 14,
                      color: 'white',
                      padding: 10,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between'
                    }}>
                    <a href={item.url} target="_blank">
                      <span>{item.name}</span>
                    </a>
                    <span
                      onClick={() => this.deleteFile(item.url)}
                      style={{
                        float: 'right',
                        width: 20,
                        textAlign: 'right',
                        cursor: 'pointer'
                      }}>
                      X
                    </span>
                  </div>
                </Col>
              ))}
          </Row>

          <div style={styles.titleDiv}>
            <h3 style={styles.title}>
              {t(
                'How did you feel about what you experienced in this project?'
              )}
            </h3>
          </div>
          <div
            onClick={() => disabled && this.setState({ disabledPopup: true })}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: 20
            }}>
            <div
              onClick={() => this.toggleEmoticon(0)}
              style={this.getEmoticonStyle(0)}>
              <img src={love} style={styles.emotionImg} />
              <p style={styles.emotionTxt}>Love</p>
            </div>
            <div
              onClick={() => this.toggleEmoticon(1)}
              style={this.getEmoticonStyle(1)}>
              <img src={fascination} style={styles.emotionImg} />
              <p style={styles.emotionTxt}>Fascination</p>
            </div>
            <div
              onClick={() => this.toggleEmoticon(2)}
              style={this.getEmoticonStyle(2)}>
              <img src={excitement} style={styles.emotionImg} />
              <p style={styles.emotionTxt}>Excitement</p>
            </div>
            <div
              onClick={() => this.toggleEmoticon(3)}
              style={this.getEmoticonStyle(3)}>
              <img src={joy} style={styles.emotionImg} />
              <p style={styles.emotionTxt}>Joy</p>
            </div>
            <div
              onClick={() => this.toggleEmoticon(4)}
              style={this.getEmoticonStyle(4)}>
              <img src={boredom} style={styles.emotionImg} />
              <p style={styles.emotionTxt}>Boredom</p>
            </div>
            <div
              onClick={() => this.toggleEmoticon(5)}
              style={this.getEmoticonStyle(5)}>
              <img src={worry} style={styles.emotionImg} />
              <p style={styles.emotionTxt}>Worry</p>
            </div>
            <div
              onClick={() => this.toggleEmoticon(6)}
              style={this.getEmoticonStyle(6)}>
              <img src={sad} style={styles.emotionImg} />
              <p style={styles.emotionTxt}>Sad</p>
            </div>
            <div
              onClick={() => this.toggleEmoticon(7)}
              style={this.getEmoticonStyle(7)}>
              <img src={anger} style={styles.emotionImg} />
              <p style={styles.emotionTxt}>Anger</p>
            </div>
          </div>

          <div style={styles.titleDiv}>
            <h3 style={styles.title}>
              {t('Why did you choose this emoticon?')}
            </h3>
          </div>
          <div
            onClick={() => disabled && this.setState({ disabledPopup: true })}>
            <TextArea
              onBlur={() => this.saveData()}
              rows={4}
              disabled={disabled || projectCompleted}
              onClick={() => disabled && this.setState({ disabledPopup: true })}
              onChange={e => this.setState({ why_emoticon: e.target.value })}
              style={{
                marginTop: 10,
                border: `1px solid ${color}`,
                fontSize: 16
              }}
              value={this.state.why_emoticon}
            />
          </div>

          <div style={styles.titleDiv}>
            <h3 style={styles.title}>{t('Notes')}</h3>
            <Tooltip title="Optional - Use the notes box if you'd like to add more information or reflections that you haven't included in the other sections.">
              <img style={{ height: 16, width: 16 }} src={this.props.icon} />
            </Tooltip>
          </div>
          <div
            onClick={() => disabled && this.setState({ disabledPopup: true })}>
            <TextArea
              onBlur={() => this.saveData()}
              disabled={disabled || projectCompleted}
              rows={4}
              onClick={() => disabled && this.setState({ disabledPopup: true })}
              onChange={e => this.setState({ notes: e.target.value })}
              style={{
                marginTop: 10,
                border: `1px solid ${color}`,
                fontSize: 16
              }}
              value={this.state.notes}
            />
          </div>

          <MultipleSelect
            t={t}
            selected={this.state[this.state.editingSelection]}
            color={this.props.color}
            field={this.state.editingSelection}
            close={() => this.setState({ editingSelection: false })}
            open={this.state.editingSelection !== false}
            confirm={this.confirmMultiple}
            mode={this.state.mode}
          />
          <ReviewPopup
            open={this.state.reviewPopup}
            close={() => this.setState({ reviewPopup: false })}
            dontShow={this.dontShowPopup}
            color={color}
          />
          {!projectCompleted && (
            <DisabledPopup
              open={this.state.disabledPopup}
              close={() => this.setState({ disabledPopup: false })}
              color={color}
            />
          )}
        </div>
        <div
          onClick={() =>
            this.props.currentPhase >= 4 &&
            !this.isDisabled() &&
            !projectCompleted &&
            !disabled &&
            this.saveData(true)
          }
          style={
            this.isDisabled() ||
            projectCompleted ||
            disabled ||
            this.props.currentPhase < 4
              ? styles.disabledNextBtn
              : styles.nextBtn
          }>
          {t('Next Phase')}
        </div>
      </div>
    );
  }
}

export default Reflection;

const emotions = [
  'Love',
  'Fascination',
  'Excitement',
  'Joy',
  'Boredom',
  'Worry',
  'Sad',
  'Anger'
];



// WEBPACK FOOTER //
// ./src/containers/StudentApp/components/reflection.js